import { render } from "./my-announcements.vue?vue&type=template&id=896bd226&scoped=true"
import script from "./my-announcements.vue?vue&type=script&lang=js"
export * from "./my-announcements.vue?vue&type=script&lang=js"

import "./my-announcements.vue?vue&type=style&index=0&id=896bd226&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896bd226"]])

export default __exports__